module.exports = __webpack_public_path__ + "img/coverBanner.739abcc0.jpg";